var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 270.92 270.92",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.45 48.17H51.69c-4.39 0-7.93 3.55-7.93 7.94 0 4.39 3.54 7.92 7.93 7.92h166.76c11.12 0 20.17 9.07 20.17 20.19v.77H51.69c-4.39 0-7.93 3.53-7.93 7.92 0 4.38 3.54 7.93 7.93 7.93h186.93v85.87c0 11.11-9.05 20.18-20.17 20.18H52.46c-11.12 0-20.17-9.07-20.17-20.18V83.43c0-4.39-3.55-7.94-7.93-7.94-4.39 0-7.94 3.55-7.94 7.94v103.28c0 19.88 16.17 36.04 36.04 36.04h165.99c19.87 0 36.05-16.16 36.05-36.04V84.22c0-19.88-16.18-36.05-36.05-36.05zm-4.63 113.28c4.38 0 7.94-3.55 7.94-7.93 0-4.4-3.56-7.93-7.94-7.93h-78.75c-4.39 0-7.94 3.53-7.94 7.93 0 4.38 3.55 7.93 7.94 7.93h78.75zM63.51 141.22h24.6v24.59h-24.6v-24.59zm32.53 40.47c4.39 0 7.94-3.55 7.94-7.95v-40.46a7.94 7.94 0 0 0-7.94-7.94H55.58c-4.39 0-7.93 3.56-7.93 7.94v40.46c0 4.4 3.54 7.95 7.93 7.95h40.46z",
    fill: "#ff7b26",
    fillRule: "nonzero",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a431f8ee27683a3f76bf807805d8a4d7.svg";
export { ForwardRef as ReactComponent };